import React from "react";
import { renderHotelsActions } from "./customRenderers";
import { renderEditableInput } from "../../../constants/reactUtilities";
import FilterUtility from "../../common/FilterUtility";
export const hotelsDataColumns = (onChangeMethod, isEditable, deleteVenue) => {
  return [
    {
      Header: "Hotel",
      id: "name",
      accessor: "name",
      Cell: renderEditableInput.bind(this, "hotels.data.$.", "name", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderHotelsActions.bind(this, deleteVenue),
      style: { textAlign: "center" }
    }
  ];
};
export const hotelModalDataColumns = (onChangeMethod, deleteVenue) => {
  return [
    {
      Header: "Hotel",
      id: "name",
      accessor: "name",
      Cell: renderEditableInput.bind(this, "newHotels.$.", "name", true, onChangeMethod, "text"),
      style: { textAlign: "center" }
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderHotelsActions.bind(this, deleteVenue),
      style: { textAlign: "center" }
    }
  ];
};
